import Button from '../../generic/Button/Button';
import type { AuthContextState, LoginStep } from '../context/AuthContext';
import type { AuthPage } from '../index';

const getButtonText = (step: LoginStep, page: AuthPage): 'Next' | 'Continue' | 'Sign In' | 'Sign Up' => {
  if (step === 'enterEmail') {
    return 'Next';
  }
  if (step === 'selectOrg') {
    return 'Continue';
  }
  return page === 'login'
    ? 'Sign In'
    : 'Sign Up';
};

type FormSubmitButtonProps = Pick<AuthContextState, 'page' | 'step' | 'status' | 'submitButton' | 'hidePasswordInput'>;

/**
 * SubmitButton for the AuthForm.
 */
const AuthFormSubmitButton = ({
  page,
  step,
  status,
  submitButton,
  hidePasswordInput,
}: FormSubmitButtonProps) => {
  //  If the password button is being hidden + we are on the auth step,
  //  the user will be logging in via an SSO login method.
  if (hidePasswordInput && step === 'authenticate') {
    return null;
  }
  // Don't render the submit button when verifying MFA
  if (step === 'verifyMfa') {
    return null;
  }
  return (
    <Button
      type="primary"
      size="large"
      onClick={submitButton.onSubmit}
      isDisabled={submitButton.isDisabled || status?.loading}
      testId="auth-submit-button"
      isFullWidth
    >
      {getButtonText(step, page)}
    </Button>
  );
};

export default AuthFormSubmitButton;
